import { User } from '../../user/User.interface';

// targetEntities taken from /migration/1621462509891-TaskTypeTargetEntity.ts
export enum TaskTypeEntity {
  Training = 'Training',
  Risk = 'Risk',
  File = 'File',
  Capa = 'Capa',
  Supplier = 'Supplier',
  Scar = 'SupplierCorrectiveAction',
  Spor = 'SupplierPurchaseOrder',
  Product = 'Product',
  UserNeed = 'ProductUserNeed',
  DesignInput = 'ProductDesignInput',
  DesignOutput = 'ProductDesignOutput',
  DesignVerification = 'ProductVerification',
  DesignValidation = 'ProductValidation',
  DesignSpec = 'ProductDesignSpec',
  Hazard = 'Hazard',
  Cause = 'HazardCause',
  Control = 'HazardControl',
  Action = 'HazardAction',
  ChangeOrder = 'ChangeOrder'
}

export interface TaskType {
  name: string;
  label: string;
  prefix?: string;
  targetEntity?: TaskTypeEntity | string;
  created?: Date;
  createdBy?: User;
  modified?: Date;
  modifiedBy?: User;
}

export interface TaskTypeListItem {
  id: number | string;
  apiLevel: 1 | 2;
  name: string;
  label: string;
  prefix: string;
  entity: string;
  entityId: string | null;
  entityTable: string | null;
  modified: Date;
  modifiedBy: User;
}
